const MAX_STORES_PER_TYPE = 20;

const registries = new Map();
const accessOrder = new Map();

function touchAccess(type, componentId) {
  if (!accessOrder.has(type)) accessOrder.set(type, []);
  const order = accessOrder.get(type);
  const idx = order.indexOf(componentId);
  if (idx !== -1) order.splice(idx, 1);
  order.push(componentId);
}

function evictIfOverLimit(type) {
  const typeRegistry = registries.get(type);
  const order = accessOrder.get(type);
  if (!typeRegistry || !order) return;

  while (order.length > MAX_STORES_PER_TYPE) {
    const oldest = order.shift();
    typeRegistry.delete(oldest);
  }
}

export function getComponentStore(type, componentId, storeFactory) {
  if (!registries.has(type)) registries.set(type, new Map());
  const typeRegistry = registries.get(type);

  if (!typeRegistry.has(componentId)) {
    typeRegistry.set(componentId, storeFactory());
    touchAccess(type, componentId);
    evictIfOverLimit(type);
  } else {
    touchAccess(type, componentId);
  }

  return typeRegistry.get(componentId);
}

export function evictComponentStore(type, componentId) {
  const typeRegistry = registries.get(type);
  if (typeRegistry) typeRegistry.delete(componentId);

  const order = accessOrder.get(type);
  if (order) {
    const idx = order.indexOf(componentId);
    if (idx !== -1) order.splice(idx, 1);
  }
}

export function evictAllForType(type) {
  registries.get(type)?.clear();
  accessOrder.get(type)?.splice(0);
}

export function evictAll() {
  registries.clear();
  accessOrder.clear();
}
